export const SITE_NAME = 'Fans4ONEOKROCK';
export const SITE_EMAIL = 'fans4oneokrock@gmail.com';

export const BAND_ID = 'one_ok_rock';
export const BAND_NAME = 'ONE\xa0OK\xa0ROCK';
export const SHORT_BAND_NAME = 'OOR';
export const BAND_NAME_JP = 'ONE\xa0OK\xa0ROCK';
export const SHORT_BAND_NAME_JP = 'ワンオク';
export const BAND_NAME_NUMBER = '10969';
export const BAND_MEMBERSHIP = 'PRIMAL FOOTMARK';
export const BAND_FANBASE_NAME = 'ONE\xa0OK\xa0ROCKers';

export const enum AppLocale {
  EN = 'en',
  JP = 'ja'
}

export enum ButtonsSizes {
  Small = 'small',
  Normal = 'normal',
  Large = 'large'
}

export enum ButtonTypes {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset'
}

export enum ButtonVariants {
  Button = 'button',
  Icon = 'icon',
  Link = 'link'
}
export enum ButtonColors {
  Primary = 'primary',
  Secondary = 'secondary',
  PrimaryDark = 'primaryDark',
  SecondaryDark = 'secondaryDark'
}

export enum InputTypes {
  Text = 'text',
  File = 'file',
  Email = 'email',
  Number = 'number'
}

export enum ButtonFontSizes {
  Small = '1.4rem',
  Normal = '1.6rem',
  Large = '1.8rem'
}
export enum ButtonHeightSizes {
  Small = '3rem',
  Normal = '4rem',
  Large = '5rem'
}

export const SAFARI_BAR_VH = 0.01;
export const VIEWPORT_SIZE_CHECKING_DELAY = 500;
